import { useCallback, useEffect, useMemo, useState } from 'react';

import { Input, Modal, Spin, Tag, Typography } from 'antd';
import _ from 'lodash';

import { getClient } from '../../../store/features/clients/clientsSlice';
import { getCurrentUser } from '../../../store/features/users/usersSlice';
import { useAppDispatch, useAppSelector } from '../../../store/index';
import ChangePasswordForm from '../../containers/forms/ChangePasswordForm/ChangePasswordForm';
import Button from '../../elements/Button/Button';
import ViewWrapper from '../../elements/ViewWrapper';

import './AccountSettingsView.less';

const { Text, Title } = Typography;

const AccountSettingsView = () => {
  const dispatch = useAppDispatch();
  const { currentUser, fetchingUser } = useAppSelector((state) => state.users);
  const { myClient } = useAppSelector((state) => state.clients);
  const [changePasswordModalOpen, setChangePasswordModalOpen] = useState(false);

  const fetchCurrentUser = useCallback(() => {
    dispatch(getCurrentUser());
  }, [dispatch]);

  useEffect(() => {
    fetchCurrentUser();
  }, [dispatch, fetchCurrentUser]);

  useEffect(() => {
    const clientId = currentUser?.client_id?.toString().trim();
    if (!clientId) {
      return;
    }

    dispatch(getClient({ id: clientId, me: true }));
  }, [currentUser?.client_id, dispatch]);

  const clientName = useMemo(() => {
    const clientId = currentUser?.client_id?.toString().trim();
    if (!clientId) {
      return 'Unavailable';
    }
    return myClient?.name ?? '';
  }, [myClient?.name, currentUser?.client_id]);

  return (
    <ViewWrapper>
      {fetchingUser ? (
        <div className="card-container">
          <Spin />
        </div>
      ) : (
        <div className="card-container">
          <div className="card">
            <Title level={5}>User Information</Title>
            <Text type="secondary" className="head">
              Username
            </Text>
            <Input disabled value={currentUser?.name} />
            <Text type="secondary" className="head">
              Email
            </Text>
            <Input disabled value={currentUser?.email} />
            <Text type="secondary" className="head">
              Client
            </Text>
            <Input disabled value={clientName} />
            <Text type="secondary" className="head">
              Role
            </Text>
            <div>
              {_.uniqBy(currentUser?.roles, 'display_name').map(
                (p: { display_name: string }) => {
                  if (!!p.display_name) {
                    return (
                      <Tag
                        color="#EBF9FC"
                        style={{ color: '#003D4C', borderColor: '#003D4C' }}
                      >
                        {p.display_name}
                      </Tag>
                    );
                  }
                  return null;
                }
              )}
            </div>
            <Text type="secondary" className="head">
              Password
            </Text>
            <Input type="password" disabled value="****************" />
            <Button
              type="link"
              className="link-button"
              onClick={() => setChangePasswordModalOpen(true)}
              style={{ alignSelf: 'flex-start' }}
            >
              Change Password
            </Button>
          </div>
          <Modal
            key={currentUser?.uuid}
            open={changePasswordModalOpen}
            title={'Change Password'}
            footer={null}
            onCancel={() => {
              setChangePasswordModalOpen(false);
            }}
          >
            <ChangePasswordForm userId={currentUser?.uuid} />
          </Modal>
        </div>
      )}
    </ViewWrapper>
  );
};

export default AccountSettingsView;
